




















































import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CentralViewCard from '@/CentralViewCard.vue';
import gql from 'graphql-tag';
import _ from 'lodash';

import * as PROJECT_DESCRIPTION_FRAGMENT_QUERY from 'src/graphql/ProjectDescriptionFragment.graphql';

@Component
export default class NotesCard extends CentralViewCard {

  name = 'NotesCard';

  description = this.project.description;
  updateDescriptionDebounced = _.debounce(this.updateDescription, 1000);

  get card() {
    return this.$store.getters.getCard(this.name);
  }

  get project() {
    return this.$store.state.currentProject;
  }

  get projectLoaded() {
    return this.project.id !== undefined;
  }

  @Watch('card.isOpen')
  onCardOpen() {
    if (this.card.isOpen) {
      // This is needed for auto-grow initial size.
      const description = this.description;
      this.description = this.description + " ";

      this.$nextTick(() => {
        this.description = description;
      });
    }
  }

  @Watch('project.description')
  onProjectDescription() {
    // Wait until project description is received
    if (this.description !== this.project.description) {
      this.description = this.project.description;
    }
  }

  @Watch('description')
  onWatchDescription() {
    this.updateDescriptionDebounced();
  }

  updateDescription() {
    if (this.description === this.project.description)
      return;

    this.$apollo.mutate({
      mutation: gql`mutation ($id: Int!, $description: String!) {
          projectUpdateDescription(id: $id, description: $description) {
            ...ProjectDescription
          }
        }
        ${PROJECT_DESCRIPTION_FRAGMENT_QUERY}
      `,
      variables: {
        id: this.project.id,
        description: this.description,
      },
      context: {
        debounceKey: 'ProjectDescription',
      },
      update: (store, {data: { projectUpdateDescription }}) => {

        store.writeFragment({
          id: `Project:${this.project.id}`,
          fragment: PROJECT_DESCRIPTION_FRAGMENT_QUERY,
          data: {
            description: this.description,
            __typename: 'Project',
          }
        });

      },
      optimisticResponse: {
        __typename: 'Mutation',
        projectUpdateDescription: {
          __typename: 'Project',
          description: this.description
        },
      },
    });
  }

  created() {
    this.name = 'NotesCard';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NotesCard.vue